import React from 'react';
import ReactECharts from 'echarts-for-react';

const LineChart = ({ data }) => {

    const option = {
        tooltip: {
            trigger: 'axis',
        },
        legend: {
            top: '0',
            right: '10',
            data: ['GST', 'Total Amount', 'Payment Received', 'Pending Payment'],
        },
        grid: {
            top: 60,
            left: 50,
            right: 15,
            bottom: 30,
        },
        xAxis: {
            type: 'category',
            data: data.months,
        },
        yAxis: {
            type: 'value',
            axisLabel: {
                formatter: function (value) {
                    if (value >= 100000) return value / 100000 + 'L';
                    if (value >= 10000000) return value / 10000000 + 'Cr';
                    if (value <= 100000) return value / 100000 + 'L';
                    if (value <= 10000000) return value / 10000000 + 'Cr';
                    return value;
                },
            },
        },
        series: [
            {
                name: 'GST',
                type: 'line',
                data: data.gst,
                smooth: true,
            },
            {
                name: 'Total Amount',
                type: 'line',
                data: data.totalAmount,
                smooth: true,
            },
            {
                name: 'Payment Received',
                type: 'line',
                data: data.paymentReceived,
                smooth: true,
            },
            {
                name: 'Pending Payment',
                type: 'line',
                data: data.pendingPayment,
                smooth: true,
            },
        ],
    };

    return <ReactECharts option={option} style={{ height: '400px', width: '100%' }} />;
};

export default LineChart;